import { render, staticRenderFns } from "./StudyCalendar.vue?vue&type=template&id=90a6f632&scoped=true"
import script from "./StudyCalendar.vue?vue&type=script&lang=js"
export * from "./StudyCalendar.vue?vue&type=script&lang=js"
import style0 from "./StudyCalendar.vue?vue&type=style&index=0&id=90a6f632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a6f632",
  null
  
)

export default component.exports